<template>
  <div id="error">
    <main>
      <div class="kglogo" :style="kgLogoStyle"></div>
      <div class="content">
        <div v-for="(message, index) in errorMessages" :key="'error-' + index">{{message}}</div>
        <div class="toplink"><a @click="toLogin()">ログイン画面へ戻る</a></div>
      </div>
    </main>
  </div>
</template>

<script>
import * as App from '../../utils/App'

export default {
  name: 'Error',
  components: {
  },
  data () {
    return {
      errorMessages: ['システムエラーが発生しました。', 'しばらく時間をおいてから、再度操作してください。'],
      kgLogoStyle: {
        background: 'url(' + this.getImage() + ') no-repeat 0 0',
        backgroundSize: 'auto 24px',
        webkitBackgroundSize: 'auto 24px',
        mozBackgroundSize: 'auto 24px'
      }
    }
  },
  methods: {
    toLogin: function () {
      this.$router.push({
        name: 'KgLogin'
      })
    },
    getImage: function () {
      return App.getKagullResource('logo1.png')
    }
  },
  created () {
    if (this.$route.params.errorMessages) {
      this.errorMessages = this.$route.params.errorMessages
    }
  }
}
</script>
<!--
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>
-->
<style lang="scss" scoped>
#error {
  height: 100%;
}
main {
  height: 100%;
  text-align: center;
  color: #ff4500;
  font-weight: bold;
  word-wrap: break-word;
  line-height: 25px;
  padding: 0;
  overflow: auto;
  .kglogo {
    float:left;
    margin:28px 0 0 20px;
    width:74px;
    height:24px;
  }
  .content {
    padding: 20px;
    margin-top: 83px;
    background-color: white;
    height: calc(100% - 123px);
  }
  .toplink {
    margin-top: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/Error.vue